/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export enum EventNames {
  METHOD_OPEN = 'open',
  METHOD_SEND = 'send',
  EVENT_ABORT = 'abort',
  EVENT_ERROR = 'error',
  EVENT_LOAD = 'loaded',
  EVENT_TIMEOUT = 'timeout',
}



// WEBPACK FOOTER //
// ../../../src/enums/EventNames.ts